import { Component, Prop, Vue } from 'vue-property-decorator';

interface Item {
  label: string;
}

@Component
export default class MoreOption extends Vue {
  @Prop() items: Item[];
  @Prop() values: boolean[];

  private checkboxValues = [] as boolean[];

  setCheckboxValues(items: Item[]): boolean[] {
    return [...Array(items.length || 0).fill(false)];
  }

  get isItemEmpty(): boolean {
    return !!this.items.length;
  }

  get dropDownItems(): string[] {
    return [...this.items].map(({ label }) => label.charAt(0).toLocaleUpperCase() + label.slice(1));
  }

  get isChecked(): boolean {
    return !!this.checkboxValues.some(value => value);
  }

  onCheckboxChanged(isCheck: boolean, index: number): void {
    const values = [...this.checkboxValues];
    values[index] = isCheck;
    this.$emit('onCheckboxChanged', values);
    this.checkboxValues = values;
  }

  onClear(): void {
    this.checkboxValues = [...this.checkboxValues].fill(false);
    this.$emit('onCheckboxChanged', this.checkboxValues);
  }

  created(): void {
    if (this.values && this.values.length > 0) {
      this.checkboxValues = [...this.values];
    } else {
      this.checkboxValues = this.setCheckboxValues(this.items || []);
    }
  }
}
